import "./errors.scss";
import * as React from "react";
import BackButton from "../Buttons/BackButton";
import RetryButton from "../Buttons/RetryButton";

interface Props {
    onBack?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    onRetry?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    fill?: boolean;
    children?: React.ReactNode;
}

export default class GeneralError extends React.Component<Props> {
    public render(): React.ReactNode {
        return (
            <div className={"error-general" + (this.props.fill ? " error-fill" : "")}>
                <h2>An error has occurred</h2>
                {this.props.children}
                <div className="error-buttons">
                    {this.props.onBack && <BackButton onClick={this.props.onBack} />}
                    {this.props.onRetry && <RetryButton onClick={this.props.onRetry} />}
                </div>
            </div>
        );
    }
}
